import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tenantDetails ? _c(VContainer, {
    staticClass: "pa-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fluid": ""
    }
  }, [_vm.userCreateProgress > 0 && _vm.userCreateProgress < 100 ? _c(VDialog, {
    attrs: {
      "value": true,
      "fullscreen": ""
    }
  }, [_c(VContainer, {
    staticClass: "fill-height",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.5)"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VProgressLinear, {
    attrs: {
      "active": true,
      "background-opacity": 0.1,
      "color": _vm.color,
      "value": _vm.userCreateProgress
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c(VForm, {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('accMgmt.user.bulkCreate'),
      "formIsValid": _vm.valid && !!_vm.scope,
      "saveButton": "",
      "cancelButton": ""
    },
    on: {
      "saveData": _vm.handleSubmit,
      "cancel": _vm.cancelUserEdit
    }
  }), _c(VRow, {
    staticClass: "pl-4 pb-4 pr-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c('core-n20Card', [_c(VCardText, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-0 pt-0 pr-0 mr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('h4', {
    staticClass: "pt-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.tenant')) + ":")])]), _c(VCol, {
    staticClass: "mt-0 pt-0 pl-0 ml-0",
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_vm.tenantDetails.ancestors.length ? _c(VBreadcrumbs, {
    attrs: {
      "items": _vm.tenantDetails.ancestors,
      "large": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VBreadcrumbsItem, {
          attrs: {
            "disabled": !item.disabled
          }
        }, [_vm._v("\n                      " + _vm._s(item.name.toUpperCase()) + "\n                    ")])];
      }
    }], null, false, 7338606)
  }) : _c('h4', {
    staticClass: "pl-3 pt-1"
  }, [_vm._v(_vm._s(_vm.tenantDetails.name))])], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('accMgmt.user.bulkDescriptionText')) + "\n                ")]), _c('p', {
    staticStyle: {
      "font-family": "monospace"
    }
  }, [_vm._v("\n                  Firstname;Lastname;Email;{\n                  "), _vm.tenantDetails.data && _vm.tenantDetails.data.userDefaultProperties ? _c('span', _vm._l(_vm.tenantDetails.data.userDefaultProperties, function (key) {
    return _c('span', {
      key: key
    }, [_vm._v("\n                      \"" + _vm._s(key) + "\":\"value\",\n                    ")]);
  }), 0) : _vm._e(), _vm._v("\n                  \"sampleKey\":\"value\" }\n                ")]), _c(VTextarea, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.user.bulkUserData'),
      "rules": _vm.csvRules,
      "validate-on-blur": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.userDataCsv,
      callback: function ($$v) {
        _vm.userDataCsv = $$v;
      },
      expression: "userDataCsv"
    }
  })], 1), _vm.faultyUserDataCsv && _vm.faultyUserDataCsv.length > 0 ? _c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_c('p', {
    staticClass: "error pa-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.bulkFaultyUser')))]), _c(VTextarea, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.user.bulkUserData')
    },
    model: {
      value: _vm.faultyUserDataCsv,
      callback: function ($$v) {
        _vm.faultyUserDataCsv = $$v;
      },
      expression: "faultyUserDataCsv"
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.accountMgmtPermissionsGroup')))])]), !_vm.scope ? _c(VCol, {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.selectedScope')))]), _vm.tenantDetails ? _c('core-tenant-scope-tree', {
    attrs: {
      "activeScopeId": _vm.tenantDetails.scopeId,
      "subject": "UserManagement",
      "action": "create"
    },
    on: {
      "update": _vm.didSelectScope
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.scope ? _c(VCol, {
    staticClass: "px-1 py-0",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('core-tenant-scopes-permissions-list', {
    attrs: {
      "loading": _vm.access.length === 0,
      "userAccess": _vm.access
    },
    on: {
      "updatedUserAccess": _vm.updatedUserAccess
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('accMgmt.user.bulkPasswordNotice')) + "\n                ")]), _c('core-password-field', {
    attrs: {
      "label": _vm.$i18n_t('Common.password'),
      "rules": _vm.passwordRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autocomplete": "new-password",
      "show-password": "",
      "required": ""
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };